// extracted by mini-css-extract-plugin
export default {"LoadText":"loadText_LoadText__S4q86","Light":"loadText_Light__Gd8kk"};